import { GenerateSEBConfigModel, IExam, IExaminationSchedule, IQuestionCategory, IExaminationGroup } from './dto';

export const examDefault: IExam = {
    id: 0,
    examinationName: '',
    session: '',
    duration: 0,
    questionSelectionMode: '',
    numberofQuestionsPerCategory: 0,
    requireProctorStart: false,
    examinationType: '',
    showScoreWhenFinished: false,
    numberOfQuestions: 0,
    examStartDate: null,
    examEndDate: null,
    selfRegistrationEndDate: null,
    selfSchedule: false,
    selfRescheduleAfter: false,
    requireAdminStart: false,
    enforceScheduleEndTime: false,
    adminStartTime: null,
    showSubmitButtonOnEveryQuestion: false,
    examinationTypeenum: '',
    externalExaminationID: '',
    subject: '',
    instructionsHTML: '',
    postExamMessages: '',
    emailNotificationTemplate: '',
    randomiseOptions: false,
    practiceExam: false,
    calculatorType: 'None',
    examPaused: false,
    detectFocusLoss: false,
    permissibleDurationOfLoss: 0,
    noOfTimesAllowedForFocusLoss: 0,
    lossOfFocusAction: '',
    lossofFocusReduceTimeActionDuration: 0,
    lossofFocusRestartActionLimit: 0,
    passportMandatory: false,
    skipAIPassportCheck: false,
    useSEB: false,
    useCaptcha: false,
    liteMode: false,
    allowComplaint: false,
    allowExamRetake: false,
    maxRetake: 0,
    answeredQuestionsPercentage: 0,
    examinationDurationPercentage: 0,
    excludeFromRDSConfigCalculation: false,
    sectionalizedEssayMarking: false,
    proctorAccessCodes: '',
    maximumNumberOfEssayAnswers: 0,
    maximumNumberOfSAQAnswers: 0,
    examinationGroupID: '',
    mockExam: false,
    showQuestionList: false,
    useQuestionBank: false,
    examQuestionBanks: [],
    scheduleFile: null,
    notifyCandidatesByEmail: false,
    allowExternalPrimaryWebcam: false,
    allowExternalSecondViewWebcam: false,
    requireSecondView: false,
    noPrimaryStreamPolicy: 'Reject',
    noSecondViewStreamPolicy: 'Warn',
    questionFormat: '',
    questionFile: null,
    emailMessage: '',
    useRawHTML: false,
    psychometricTest: false,
    recording: false,
    facialRecognition: false,
    aIProctoring: false,
    liveProctoring: false
};

export const generateSEBConfigModelDefault: GenerateSEBConfigModel = {
    id: 0,
    prohibitedProcesses: '',
    maxNoOfDisplays: 0,
    permittedProcesses: ''
};  

export const examinationScheduleDefault: IExaminationSchedule ={
    id: 0,
    examNo: '',
    examinationID: 0,
    startDateTime: null,
    actualStartDateTime: null,
    addedMinutes: 0,
    totalAddedTimeInSeconds: 0,
    examPaused: false,
    endDateTime: null,
    actualEndDateTime: null,
    status: '',
    score: 0,
    percentageScore: 0,
    focusLossCount: 0,
    examStartCount: 0,
    canTakeExam: false,
    sEBConfigKey: '',
    sEBConfigKeyVersion: 0,
    interviewProctorRequestID: 0,
    //viewedQuestions: false,
    extraField1: '',
    extraField2: '',
    extraField3: '',
    extraField4: '',
    attempt: 0,
    timeTaken: null,
    lastInteraction: null,
    networkAvailabilityScore: 0,
    overrideAIPreventExamStart: false,
    recordingProcessStatus: '',
    recordingDeleted: false,
    randomGuid: '',
    restartReason: '',
    retakeCount: 0,
    examiner: '',
    lastCheckedForImport: null,
    lastUpdateId: '',
    disableSEB: false,
    allowExternalWebcam: false,
    overrideRequireSecondView: false
}

export const questionCategoryDefault: IQuestionCategory = {
    id: 0,
    category: '',
    description: ''
};

export const examinationGroupDefault: IExaminationGroup = {
    id: 0,
    examinationGroupID: '',
    name: '',
    noOfExam: 0
};